import { render, staticRenderFns } from "./shortAnswer.vue?vue&type=template&id=0b329e9c&scoped=true&"
import script from "./shortAnswer.vue?vue&type=script&lang=js&"
export * from "./shortAnswer.vue?vue&type=script&lang=js&"
import style0 from "./shortAnswer.vue?vue&type=style&index=0&id=0b329e9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b329e9c",
  null
  
)

export default component.exports